<template>
    <div class="index">
        <div class="banner">
            <a href="#">
                <img src='http://late-care.tuolele.cn/banner2.496eba8.png' class="img_banner" alt="大学生网上兼职">
            </a>
        </div>
        <div class="box">
            <div class="part-timeJob">
                <div class="know_top">
                    <span></span>
                    <h1>三步教你如何在家做兼职</h1>
                </div>   
                <div class="img_one">
                    <div class="div_dl div_title">
                        <div>
                            <span>1.</span>
                            <h1>免费注册账号，完成能力测评</h1>
                        </div>
                        <p>绝无任何收费流程,仅需线上注册账号<br>在线通过学科能力测评、批改操作教学及测评，<br>即可获得权限</p>
                    </div>
                </div>
                <div class="img_two">
                    <div class="div_dl div_once">
                        <div>
                            <span>2.</span>
                            <h1>随时随地，完成批改任务</h1>
                        </div>
                        <p>任意地点，仅需电脑和网络，就可以录入作业单<br>批改作业录入错题均可结算为薪资</p>
                    </div>
                </div>
                <div class="img_three">
                    <div class="div_dl div_title">
                        <div>
                            <span>3.</span>                            
                            <h1>积累薪资，轻松在线领取</h1>
                        </div>
                        <p>任务完成累积的薪资，可在线即时提取，多劳多得<br>让学生党，在职老师利用富余时间，轻松赚钱</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="main-duties">
            <div class="box box-top">
                <div class="know_title">
                    <span></span>
                    <span>主要工作</span>
                </div>
                <div class="img_list">
                    <ul class="list">
                        <li><img :src="Operation" class="img-job" alt="大学生网上兼职"></li>
                        <li><img :src="Correct" class="img-job" alt="大学生网上兼职"></li>
                        <li><img :src="Mistakes" class="img-job" alt="大学生网上兼职"></li>
                    </ul>
                    <div class="img_technological">
                        <img :src="Technological" class="technological" alt="大学生网上兼职">
                    </div>
                    <ul class="list-title">
                        <li>
                            <span>1.录入作业单</span>
                            <p>为学员录入今日作业任务的清单</p>
                        </li>
                        <li>
                            <span>2.批改作业</span>
                            <p>对作业进行批改如有错误需批改并给<br>出正确答案</p>
                        </li>
                        <li>
                            <span>3.录入错题</span>
                            <p>将学员作业批改结果中错误的题目<br>整理成可重复练习的题目<br>供学员复习巩固</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="min-box">
            <div class="Growth-system">
                <div class="Growth-system-title">
                    <div class="title">
                        <span></span>
                        <span>成长体系</span>
                    </div>
                    <div class="span-title">
                        <span>
                            完善的成长体系<br>
                            让每个助教辛勤的汗水都有回报<br>
                            任务高质量完成——星级成长——收益&权益增加<br>
                            随星级成长，将逐步提高星级补贴，增加助教薪资报酬<br>
                            高星级助教享有优先排班的权益，时间更稳定
                        </span>
                    </div>
                    <div class="img-practice">
                        <img :src="Elf" class="elf-gif" alt="大学生网上兼职">
                        <img :src="Practice" alt="大学生网上兼职">
                    </div>
                </div>
            </div>
        </div>
        <Suspend :btnFlag="btnFlag"></Suspend>
    </div>
</template>

<script>
import Technological from '../../assets/img/technological.png';
import Operation from '../../assets/img/operation.png';
import Correct from '../../assets/img/correct.png';
import Mistakes from '../../assets/img/mistakes.png';
import Practice from '../../assets/img/practice.png';
import Elf from '../../assets/img/elf.gif';
import Suspend from '../suspend/suspend'

export default {
    components: {
        Suspend
    },
    metaInfo: {
        title: '托乐乐-云端助教-大学生靠谱在线兼职平台',
        meta: [
            { name: 'Keywords', content: '兼职；赚钱；大学生；助教；实习；在家；在线；家教；薪资；提现' },
            { name: 'description', content: '托乐乐-云端助教-大学生轻松兼职赚小钱钱。仅需三步，即可开始在线兼职。完善的成长体系，让每份辛苦付出都有回报。' }
        ]
    },
    data () {
        return {
            Technological,
            Operation,
            Correct,
            Mistakes,
            Practice,
            Elf,
            btnFlag: ''
        }
    },
    mounted() {
        window.addEventListener('scroll', this.scrollToTop, true)
    },
    methods: {
        scrollToTop () {  
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop > 3220) {
            // if (scrollTop > 3440) {
                this.btnFlag = 'active'
            } else {
                this.btnFlag = ''
            }
        }
    }
}
</script>

<style scoped lang='scss'>
.index {
    width: 100%;
    position: relative;
    .min-box {
        max-width: 1100px;
        min-width: 1100px;
        height: 100%;
        margin: 0 auto;
        margin-bottom: 246px;
        .Growth-system {
            width: 100%;
            .Growth-system-title {
                width: 100%;
                 .title {
                    width: 100%;
                    height: 100%;
                    padding-top: 96px;
                    span {
                        &:first-child {
                            width: 19px;
                            height: 6px;
                            background-color: #32b3fd;
                            border-radius: 3px;
                            margin-bottom: 24px;
                            display: block;
                        }
                        &:last-child {
                            font-size: 32px;
                            color: #32b3fd;
                        }
                    }
                }
                .span-title {
                    font-size: 18px;
                    line-height: 34px;
                    color: #98a4b9;
                    margin-top: 24px;
                }
                .img-practice {
                    width: 100%;
                    margin-top: 88px;
                    // margin-bottom: 246px;
                    position: relative;
                    .elf-gif {
                        position: absolute;
                        left: 0;
                        bottom: 130px;
                        width: 171px;
                        height: 260px;
                    }
                }
            }
        }
    }
    .box {
        max-width: 1100px;
        min-width: 1100px;
        height: 100%;
        margin: 0 auto;
        // margin-bottom: 246px;
        .part-timeJob {
            width: 100%;
            height: 100%;
            .know_top {
                width: 100%;
                height: 100%;
                text-align: center;
                margin: 50px 0 120px 0;
                h1 {
                    font-size: 40px;
                    color: #43557a;
                    font-weight: normal;
                }
                span {
                    width: 19px;
                    height: 6px;
                    background-color: #43557b;
                    border-radius: 3px;
                    display: block;
                    margin: 25px auto;
                }
            }
            .div_dl {
                width: 500px;
                height: 150px;
                div {
                    color: #1e7ffc;
                    span {
                        font-size: 80px;
                        display: inline-block;

                    }
                    h1 {
                        display: inline-block;
                        font-size: 26px;
                        font-weight: normal;
                    }
                }
                p {
                    font-size: 18px;
                    color: #43557a;
                    line-height: 30px;
                    margin-left: 66px;
                }
            }
            .div_title {
                margin-left: 580px;
            }
            .div_once {
                padding-top: 20px;
            }
            .img_one {
                width: 100%;
                height: 399px;
                background-image: url(../../assets/img/register.png) ;
                background-repeat:no-repeat;
            }
            .img_two {
                width: 108%;
                height: 429px;
                background-image: url(../../assets/img/assistants.png);
                background-repeat:no-repeat;
            }
            .img_three {
                width: 100%;
                height: 399px;
                background-image: url(../../assets/img/git_online.png);
                background-repeat:no-repeat;
                margin-bottom: 90px;
            }
        }
    }
    .main-duties{
        height: 744px;
        background-image: url(../../assets/img/background.png);
        .box-top {
            padding-top: 59px;
            .know_title {
                width: 100%;
                height: 64px;
                text-align: center;
                span {
                    &:first-child {
                        background-color: #fff;
                        width: 19px;
                        height: 6px;
                        border-radius: 3px;
                        display: block;
                        margin: 0 auto;
                        margin-bottom: 17px;
                    }
                    &:last-child {
                        font-size: 40px;
                        color: #fff;
                    }
                }
            }
            .img_list {
                width: 100%;
                margin-top: 74px;
                .list {
                    width: 100%;
                    margin-left: 11px;
                    li {
                        float: left;
                        &:nth-child(2) {
                            margin: 0 94px;
                        }
                        .img-job {
                            width: 297px;
                            height: 250px;
                        }
                    }
                }
                .img_technological {
                    width: 100%;
                    text-align: center;
                    .technological {
                        margin-top: 21px;
                        width: 798px;
                    }
                }
                .list-title {
                    width: 100%;
                    margin-top: 19px;
                    li {
                        float: left;
                        text-align: center;
                        &:first-child {
                            width: 252px;
                            margin-left: 23px;
                        }
                        &:nth-child(2) {
                            width: 288px;
                            margin: 0 113px 0 127px;
                        }
                        &:last-child {
                            width: 270px;
                        }
                        span {
                            font-size: 30px;
                            color: #fff;
                        }
                        p {
                            font-size: 18px;
                            color: #fff;
                            margin-top: 10px;
                            line-height: 34px;
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/section/aboutus.vue